module.exports = __webpack_public_path__ + "static/media/taman-negara.bbd22b9a.jpeg";